export default {
  seo: {
    home: {
      title: 'Artemida Studio — Solutions numériques créatives',
      description:
        'Nous créons des sites web sur mesure de toute complexité : pages d’atterrissage, sites d’entreprise et assistants IA.',
      keywords: 'développement web, page d’atterrissage, site d’entreprise, IA',
    },
    // 🔽 nouveau : SEO pour la liste du blog
    blog: {
      title: 'Blog — Artemida Studio',
      description:
        'Analyses sur le développement web, le design, les assistants IA et la création de sites web modernes pour les entreprises.',
      keywords: 'blog, développement web, design, ia, sites web',
    },
  },

  header: {
    homeLink: 'Accueil',
    aboutUsLink: 'À propos',
    servicesLink: 'Services',
    ourProjectsLink: 'Nos projets',
    contact: 'Contact',
    blogLink: 'Blog',
  },
  heroSection: {
    companyDescription:
      'Nous créons des sites web sur mesure de toute complexité',
    contactUs: 'Contactez-nous',
  },
  aboutUsSection: {
    aboutUsTitle: 'À propos',
    aboutUsDescription:
      'Chez Artemida Studio, nous sommes spécialisés dans la création de landing pages et de sites corporate sur mesure qui aident les entreprises à renforcer leur présence en ligne. Notre mission est de fournir des solutions modernes, fonctionnelles et visuellement percutantes, adaptées aux besoins de votre marque.\n\n' +
      'En associant créativité, technologies de pointe et approche personnalisée, nous concevons des sites non seulement esthétiques, mais aussi rapides, intuitifs et entièrement responsives.\n\n' +
      'Que vous ayez besoin d’une landing page à forte conversion ou d’un site d’entreprise professionnel, Artemida Studio est là pour donner vie à votre vision avec des solutions sur mesure de haute qualité.\n\n' +
      'Choisissez le professionnalisme et la créativité — construisons ensemble votre site idéal !',
  },

  // Services (i18n керує всією секцією)
  services: {
    ourServices: 'Nos services',
    servicesDescription:
      'Nous concevons des solutions numériques sur mesure et de haute qualité pour faire grandir votre activité',
    contactUs: 'Contactez-nous',
    items: [
      {
        key: 'landing',
        title: 'Landing \n Page',
        descriptionList: [
          'Une landing page bien conçue est un levier puissant pour attirer des clients, augmenter les conversions et renforcer la présence en ligne de votre marque. Chez Artemida Studio, nous créons des landing pages sur mesure et de haute qualité, alignées sur vos objectifs.',
          '✔️ Design moderne & unique — Des pages visuellement percutantes et cohérentes avec votre identité de marque.',
          '✔️ Forte capacité de conversion — Layouts optimisés et appels à l’action convaincants pour stimuler l’engagement.',
          '✔️ Rapide & responsive — Performances fulgurantes et expérience fluide sur tous les appareils.',
          '✔️ Prête pour le SEO & le marketing — Conçue selon les bonnes pratiques pour améliorer la visibilité et le trafic organique.',
          '✔️ Entièrement personnalisable — Chaque détail est adapté à vos besoins et à l’identité de votre marque.',
        ],
      },
      {
        key: 'corporate',
        title: 'Site \n d’entreprise',
        descriptionList: [
          'Un site d’entreprise professionnel est essentiel pour inspirer confiance, présenter votre marque et engager vos clients. Chez Artemida Studio, nous réalisons des sites corporate sur mesure qui reflètent vos valeurs et vous démarquent dans le monde digital.',
          '✔️ Design professionnel & unique — Un style moderne et soigné, fidèle à votre identité.',
          '✔️ Entièrement personnalisable — Chaque élément est pensé pour vos besoins et objectifs business.',
          '✔️ Rapide & sécurisé — Optimisé pour la vitesse, la sécurité et des performances irréprochables.',
          '✔️ SEO & marketing friendly — Développé selon les meilleures pratiques pour accroître votre visibilité et attirer de nouveaux clients.',
          '✔️ Mobile & user-friendly — Design entièrement responsive pour une expérience homogène sur tous les appareils.',
          '✔️ Gestion de contenu facilitée — Mises à jour simples et efficaces via un CMS intuitif.',
        ],
      },
      {
        key: 'ai',
        title: 'Intégration d’assistants IA',
        descriptionList: [
          'Boostez votre site avec la puissance de l’IA ! Chez Artemida Studio, nous intégrons des assistants IA avancés qui améliorent l’expérience utilisateur, automatisent les tâches et augmentent l’engagement. Chatbot intelligent, support automatisé ou recommandations pilotées par l’IA — nous concevons des solutions sur mesure pour votre activité.',
          '✔️ Support client 24/7 — Des chatbots IA traitent les demandes à tout moment, améliorant la satisfaction.',
          '✔️ Intégration transparente — Fonctionne de façon fluide au sein de votre site, sans perturber l’expérience.',
          '✔️ Expérience personnalisée — Des interactions pilotées par l’IA, adaptées aux besoins et préférences des utilisateurs.',
          '✔️ Leads & ventes — Engagez les visiteurs, captez des prospects et orientez-les vers l’achat.',
          '✔️ Automatisation & efficacité — Rationalisez les processus, réduisez la charge de travail et les temps de réponse.',
          '✔️ Solutions IA sur mesure — Totalement adaptables à votre modèle d’affaires et à vos exigences spécifiques.',
        ],
      },
    ],
  },
  contactSection: {
    title: 'Parlons de votre projet',
    placeholderName: 'Nom',
    placeholderPhone: 'Téléphone',
    placeholderEmail: 'E-mail',
    placeholderMessage: 'Parlez-nous de votre projet',
    sendButton: 'Envoyer',
  },
};
